const cmsEndpoints = {
    //log
    addLog: () => '/make_payment_ver_4',
    logEnabledStatus:() => '/getflagstatus?timestamp=' + new Date().getTime(),
    localBranch: zipcode => `/user/cms/content/GetBranchDetails?postcode=${zipcode}`,
    getPostalCodeStatus : (zipcode) => `appointment/ispostalcodeActive?postalcode=${zipcode}`
};

export default cmsEndpoints;